module.exports = __webpack_public_path__ + "static/img/contentLeftImg5.598f8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentLeftImg5.png
// module id = ABLH
// module chunks = 2